import Request from '../request/request';
import TokenManager from '../TokenManager';

const Auth = {

    init: (Username) => {
        return Request.post('/auth/initiate', { Username: Username.trim() }, { dont_refresh_tokens: true });
    },

    respond: (ChallengeName, ChallengeValue, otherParams = {}) => {
        return Request.post('/auth/respond', {
            ChallengeName: ChallengeName,
            ChallengeValue: ChallengeValue,
            ...otherParams,
        });
    },

    resetPassword: (Username) => {
        return Request.post('/auth/forgot-password', { Username: Username.trim() }, { dont_refresh_tokens: true, ignore401: true });
    },

    changePassword: (PreviousPassword, ProposedPassword) => {
        return Request.post('/auth/change-password', {
            AccessToken: TokenManager.fromLocalStorage().AccessToken,
            PreviousPassword: PreviousPassword,
            ProposedPassword: ProposedPassword
        }, {
                Authorization: 'Bearer ' + TokenManager.fromLocalStorage().IdToken,
                ignore401: true,
            });
    },

    saturate: (client = 'web', app = null) => {
        const params = { 'client': client, app: app };
        return Request.get('/user/saturate', params, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().IdToken })
        .then(data => normalize(data))
        .catch((err) => {
            throw new Error(err.Error);
        });
    },

    iam: () => {
        return Request.get('/user/iam', null, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken });
    },

    sessions: () => {
        return Request.get('/user/active-sessions', {}, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken });
    },

    requestApiToken: (name, ProfileId, scopes = []) => {
        return Request.post('/user/issue-api-token', {name, ProfileId, scopes}, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken });
    },

    deleteApiToken: (setId) => {
        return Request.delete(`/user/delete-api-token/${setId}`, {}, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken });
    },

    listScopes: (ProfileId) => {
        return Request.get('/user/list-scopes', {ProfileId: ProfileId}, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken });
    },

    /**
     * Globally log out of everything including SSO
     *
     */
    destroy: (providerOnly = false) => {
        let IdToken = null;

        try {
            IdToken = TokenManager.fromLocalStorage().IdToken;
        } catch { }

        let options = {
            raw: true,
            dont_refresh_tokens: true,
            ignore401: true
        }

        if (IdToken) {
            options['Authorization'] = 'Bearer ' + IdToken;
        }

        const data = providerOnly ? { ProviderOnly: 'true' } : {};
        return Request.get('/auth/logout', data, options)
        .then(response => {
            TokenManager.destroy();
            return response.json();
        })
        .catch((err) => {
            // If the API throws an error we should keep going
            TokenManager.destroy()
        });
    },

    getRedirectUrl: (profileId, client = 'web', app = null) => {
        const params = { 'client': client, app: app, ProfileId: profileId };
        return Request.post('/user/redirect', params, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().IdToken });
    },

    integration: {
        issue: (geckoChatAccountId, geckoFormAccountId) => {
            return Request.post('/integration/issue', {
                geckoChatAccountId,
                geckoFormAccountId,
            }, { Authorization: 'Bearer ' + TokenManager.fromLocalStorage().IdToken });
        }
    },

};

export const indexBy = (data, key = 'id') => {
    return data.reduce((accum, item) => {
        accum[item[key]] = item;
        return accum;
    }, {});
};

export const normalize = (data) => {
    const normalizedAccounts = {
        all: data.accounts,
        byId: indexBy(data.accounts, 'AccountId'),
    }

    const normalizedApps = {
        all: data.apps,
        byId: indexBy(data.apps, 'Id'),
    }

    let normalizeData = {
        user: data.user,
        profiles: data.profiles,
        accounts: normalizedAccounts,
        apps: normalizedApps,
    }

    return normalizeData;
}

export default Auth;
